import { errorToast } from "@/v2-ui/toast"
import {
  type ConfirmButtonProps,
  ConfirmButton,
} from "@/v2-backoffice-client/components/button"
import { useCustomerTenantRemoveManyMutation } from "@/v2-backoffice-client/customer/tenant/remove/many/customer.tenant.remove.many.mutation"

export type CustomerTenantRemoveManyButtonProps = Omit<
  ConfirmButtonProps,
  "onConfirm"
> & {
  customerId: number
  customerName: string
  tenantIds: number[]
  onCompleted?(): void
}

function CustomerTenantRemoveManyButton(
  props: CustomerTenantRemoveManyButtonProps,
) {
  const {
    customerId,
    customerName,
    tenantIds,
    confirmContent,
    onCompleted,
    ...confirmButtonProps
  } = props
  const tenantCount = tenantIds.length

  const [remove, { loading, error }] = useCustomerTenantRemoveManyMutation({
    onCompleted,
  })

  errorToast(error, {
    title: `Failed to remove ${tenantCount} team(s) from customer`,
  })

  return (
    <ConfirmButton
      variant="outline"
      size="sm"
      iconSrc="trash"
      content="Remove selected teams"
      confirmContent={
        confirmContent ??
        `Are you sure you want to remove ${tenantCount} team(s) from customer ${customerName}?`
      }
      isLoading={loading}
      onConfirm={() => {
        remove({ variables: { customerId, tenantIds } })
      }}
      {...confirmButtonProps}
    />
  )
}

export default CustomerTenantRemoveManyButton
